import React, { ReactElement } from 'react';
import classnames from 'classnames';
import { MultipleSelectOption } from '../..';
import styles from './MultipleSelectListbox.module.css';
import { MultipleSelectListboxItem } from './components/MultipleSelectListboxItem';

export type MultipleSelectListboxProps = {
  id: string;
  labelId: string;
  fieldId: string;
  options: MultipleSelectOption[];
  value: string[];
  isSelectAllActive: boolean;
  isOpen: boolean;
  disabled?: boolean;
  onChange: (value: string[]) => void;
};

export function MultipleSelectListbox({
  id,
  labelId,
  fieldId,
  options,
  value,
  isSelectAllActive,
  isOpen,
  disabled = false,
  onChange,
}: MultipleSelectListboxProps): ReactElement {
  if (!isOpen || disabled) {
    return <></>;
  }

  return (
    <ul
      id={id}
      className={classnames('dropdown__menu', styles.menu)}
      role="listbox"
      aria-multiselectable="true"
      aria-labelledby={labelId}
    >
      {options.map((option, index) => (
        <MultipleSelectListboxItem
          key={option.value}
          option={option}
          index={index}
          optionsLength={options.length}
          fieldId={fieldId}
          value={value}
          isSelectAllActive={isSelectAllActive}
          onChange={onChange}
        />
      ))}
    </ul>
  );
}
